// extracted by mini-css-extract-plugin
module.exports = {"empty":"ImprovementGraph_empty__cqf-z"};